import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "page page--offline" }
const _hoisted_2 = { class: "page__content" }
const _hoisted_3 = { key: 0 }

import {IonContent, IonPage, onIonViewDidEnter} from "@ionic/vue";
import {useI18n} from 'vue-i18n'
import {isReachable} from "@/functions";
import {ApiStatus} from "@/types";
import {reactive} from "vue";
import router from '@/router';

interface State {
    status: ApiStatus
}


export default /*#__PURE__*/_defineComponent({
  __name: 'Offline',
  setup(__props) {

const {t} = useI18n();

const state = reactive<State>({
    status: {
        done: false,
        failed: false,
        loading: false
    }
});


const retry = () => {
    state.status.loading = true;
    isReachable(window.location.origin)
        .then((online) => {
            if(online){
                router.push({ name:'home'});
            }
        }).finally(() => {
        state.status.loading = false;
    });
};

onIonViewDidEnter(()=>{
    if(navigator.onLine){
        router.push({ name:'home'});
    }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonPage), null, {
    default: _withCtx(() => [
      _createVNode(_unref(IonContent), null, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("h1", null, _toDisplayString(_unref(t)('offline.header')), 1),
              _createElementVNode("p", null, _toDisplayString(_unref(t)('offline.text')), 1),
              _createElementVNode("button", {
                class: "btn",
                onClick: retry
              }, _toDisplayString(_unref(t)('offline.button')), 1),
              (state.status.loading)
                ? (_openBlock(), _createElementBlock("p", _hoisted_3, "Loading"))
                : _createCommentVNode("", true)
            ])
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})